import { AccountFillStageEnum, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Popover, ICONS, PLATFORM_THEME_COLORS, Icon } from '@thinknet-gmbh/platform-common-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IUserData } from 'src/pages/settings/components/user-management/user-management.interfaces';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';
import { useSendSignUpEmailForMember } from 'src/hooks/members/send-sign-up-email-for-member.hook';
import { USER_MANAGEMENT_MODALS } from 'src/pages/settings/components/user-management/user-management.constants';

interface IProps {
  currentAccount: any;
  record: any;
  handleModals: (record: IUserData, modal: string) => void;
}

const UserTablePopover: FC<IProps> = ({ currentAccount, record, handleModals }) => {
  const { t } = useTranslation(['settings', 'auth']);

  const sendSignUpEmailForMember = useSendSignUpEmailForMember(record._id);

  const { canEdit, canDelete } = useUserCanManageDocument({
    createdBy: record?.createdBy || '',
    platformPermission: PLATFORM_PERMISSIONS.memberManagement,
  });

  if (!canDelete && !canEdit) {
    return <div></div>;
  }

  return (
    <Popover
      elements={[
        {
          label: t('settings:userManagementSettings.editUser.title'),
          key: ICONS.editAlt,
          icon: ICONS.editAlt,
          ...(canEdit
            ? { handler: () => handleModals(record, USER_MANAGEMENT_MODALS.editUser) }
            : { color: PLATFORM_THEME_COLORS.grayVariations.medium }),
        },
        {
          label: t('settings:userManagementSettings.editModal.title'),
          key: ICONS.edit,
          icon: ICONS.edit,
          ...(canEdit
            ? { handler: () => handleModals(record, USER_MANAGEMENT_MODALS.changePermissionGroup) }
            : { color: PLATFORM_THEME_COLORS.grayVariations.medium }),
        },
        {
          label: t('auth:buttons.resendSignUpLink'),
          key: ICONS.send,
          icon: ICONS.send,
          ...(canEdit && record.account.accountFillStage === AccountFillStageEnum.NOT_COMPLETED
            ? { handler: () => sendSignUpEmailForMember(record._id) }
            : { color: PLATFORM_THEME_COLORS.grayVariations.medium }),
        },
        {
          label: t('settings:userManagementSettings.labels.editUserPosition'),
          key: ICONS.smile,
          icon: ICONS.smile,
          ...(canEdit
            ? { handler: () => handleModals(record, USER_MANAGEMENT_MODALS.editUserPosition) }
            : { color: PLATFORM_THEME_COLORS.grayVariations.medium }),
        },
        {
          label: t('settings:userManagementSettings.deleteModal.title'),
          key: ICONS.trash,
          icon: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.medium,
          ...(canDelete && {
            handler: () => handleModals(record, USER_MANAGEMENT_MODALS.deleteUser),
          }),
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        rightMargin={false}
        color={PLATFORM_THEME_COLORS.primary.grey}
      />
    </Popover>
  );
};

export default UserTablePopover;
